<template>
  <path
    d="M1.17422 0H8.82578C9.68013 0 10.141 1.00212 9.58504 1.65079L5.75926 6.1142C5.36016 6.57981 4.63984 6.57981 4.24074 6.1142L0.414964 1.65079C-0.141042 1.00212 0.319867 0 1.17422 0Z"
  />
</template>
